<template>
  <div class="user-wrapper">
    <div class="login-page login-page--auth-inputs">
      <div class="title">UniverseX</div>
      <div class="form-list">
        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">账号</div>
          </div>
          <el-input
            v-model="form.phone"
            :class="{ error: !!errorStatus }"
            @focus="clearError"
            @keyup.enter="submitFun"
            type="text"
            placeholder="请输入手机号或账号"
            class="ipt"
            :disabled="loading"
          />
        </div>
        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">密码</div>
          </div>
          <div class="iput-box">
            <el-input
              v-model="form.password"
              :class="{ error: !!errorStatus }"
              :type="showPassword ? 'text' : 'password'"
              class="ipt"
              @focus="clearError"
              @keyup.enter="submitFun"
              placeholder="请输入密码"
              :disabled="loading"
            />
          </div>
          <div class="push" @click="showHideEye">
            <img
              v-if="showPassword"
              class="icon"
              src="@/assets/images/eye.png"
              alt=""
            />
            <img
              v-else
              class="icon"
              src="@/assets/images/eyeclose.png"
              alt=""
            />
          </div>
        </div>
        <div class="error-box flex flex-align-center" v-if="!!errorStatus">
          <img class="error-icon" src="@/assets/images/error.png" alt="" />
          <div class="msg">{{ errorStatus }}</div>
        </div>
      </div>
      <div class="more-deal flex flex-align-center">
        <img
          @click="submitFun"
          class="sure-btn"
          :class="{ disabled: loading }"
          :style="{
            opacity: loading ? 0.6 : 1,
            cursor: loading ? 'not-allowed' : 'pointer',
          }"
          src="@/assets/images/login.png"
          alt="登录"
        />
        <div v-if="loading" class="loading-text">登录中...</div>
        <div class="more">
          <div>
            <router-link class="for" :to="{ path: '/login/forgetPassword' }"
              >忘记密码？</router-link
            >
          </div>
          <router-link class="reg" :to="{ path: '/login/register' }"
            >注册</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import CryptoJS from "crypto-js";
import { login } from "@/api/login";
import { useToast } from "vue-toast-notification";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { setToken } from "@/utils/cookie";

const $toast = useToast();
// 密码显示隐藏
const showPassword = ref(false);
const loading = ref(false);
const showHideEye = () => {
  showPassword.value = !showPassword.value;
};
// 账号密码错误
const errorStatus = ref("");
const clearError = () => {
  errorStatus.value = "";
};
// 登录
const router = useRouter();
const userStore = useUserStore();
const form = ref({
  phone: "",
  password: "",
  loginType: "password",
});

// 表单验证
const validateForm = () => {
  // 清除之前的错误
  errorStatus.value = "";

  // 验证账号
  if (!form.value.phone || form.value.phone.trim() === "") {
    $toast.error("请输入账号或手机号", {
      position: "top",
    });
    return false;
  }

  // 验证密码
  if (!form.value.password || form.value.password.trim() === "") {
    $toast.error("请输入密码", {
      position: "top",
    });
    return false;
  }

  if (form.value.password.length < 6) {
    $toast.error("密码长度至少6位", {
      position: "top",
    });
    return false;
  }

  return true;
};

const submitFun = async () => {
  // 防止重复提交
  if (loading.value) {
    return;
  }

  // 表单验证
  if (!validateForm()) {
    return;
  }

  loading.value = true;
  errorStatus.value = "";

  try {
    const response = await login({
      ...form.value,
      password: CryptoJS.MD5(form.value.password).toString(),
    });

    if (response && response.code === 200) {
      $toast.success("登录成功", {
        position: "top",
        duration: 2000,
      });

      // 存储token
      setToken(response.data);
      userStore.getUser(); // 获取当前登录用户
      userStore.token = response.data; // 全局存储token

      // 清除本地存储的重定向URL
      const redirectUrl = localStorage.getItem("wantToJump");
      localStorage.removeItem("wantToJump");

      // 跳转逻辑优化
      if (
        redirectUrl &&
        redirectUrl !== "/login" &&
        redirectUrl !== "/login/index"
      ) {
        router.push(redirectUrl);
      } else if (
        document.referrer &&
        !document.referrer.includes(window.location.host)
      ) {
        // 如果有来源页面且不是当前域名，返回上一页
        router.go(-1);
      } else {
        // 默认跳转到首页
        router.push("/");
      }
    } else {
      // 处理特殊错误情况
      if (response && response.message === "您的账号已被封禁，请联系客服解决") {
        router.push("/login/breakLaw");
        return;
      }

      const errorMsg = response?.message || "登录失败，请检查账号密码";
      errorStatus.value = errorMsg;
      $toast.error(errorMsg, {
        position: "top",
      });
    }
  } catch (error) {
    console.error("登录失败:", error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      "登录失败，请稍后重试";
    errorStatus.value = errorMsg;
    $toast.error(errorMsg, {
      position: "top",
    });
  } finally {
    loading.value = false;
  }
};
</script>
<style lang="scss" scoped>
.user-wrapper {
  height: calc(100vh - 193px);
  padding-top: 86px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page {
  width: 406px;
  margin: 0 auto;

  .title {
    font-size: 48px;
    color: var(--ux-text-primary);
    line-height: 61px;
    margin-bottom: 29px;
    text-align: center;
  }
  .push {
    margin-left: 10px;
    width: 33px;
    height: 33px;
    line-height: 33px;
  }
  .icon {
    width: 100%;
    &:hover {
      cursor: pointer;
    }
  }
  .more-deal {
    margin-top: 5px;
    justify-content: center;
    position: relative;

    .sure-btn {
      width: 93px;
      height: 93px;
      transition: opacity 0.3s;
      &:hover:not(.disabled) {
        cursor: pointer;
        opacity: 0.8;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .loading-text {
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      color: #666;
    }
    .more {
      position: absolute;
      right: 18px;
      top: 35px;
    }
    .for,
    .reg {
      font-size: 14px;
      font-family: Zero G Regular-Regular, Zero G Regular;
      font-weight: 400;
      color: var(--ux-text-secondary);
      line-height: 16px;
    }
    .reg {
      margin-top: 10px;
    }
  }
  .error-box {
    position: absolute;
    bottom: 20px;
    right: 0;
    transform: translateX(calc(100% + 27px));
    .error-icon {
      margin-right: 7px;
      width: 33px;
      height: 33px;
    }
    .msg {
      // width: 100px;
      color: #d81e06;
    }
  }
}
</style>
